// extracted by mini-css-extract-plugin
export default {"toggleBtn":"toggleBtn_toggleBtn__OH0Jo"};